"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const hauling_statistic_1 = require("services/report/hauling-statistic");
const hauling_statistic_types_1 = require("./hauling-statistic.types");
const getDataGrid = ({ dataStates, start_date, end_date }) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, hauling_statistic_1._getReportHaulingStatistic)(dataStates, start_date, end_date);
    if (response.isError) {
        dispatch({
            type: hauling_statistic_types_1.haulingStatisticTypes.SET_ERROR, payload: {
                isError: response.isError,
                errorCode: response.errorCode, errorMessage: response.errorMessage
            }
        });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date), main_entrance_in_silo: new Date(item.main_entrance_in_silo).getFullYear() ===
                        2006 ? '' : new Date(item.main_entrance_in_silo), time_out_silo: new Date(item.time_out_silo).getFullYear() ===
                        2006 ? '' : new Date(item.time_out_silo), time_in_silo: new Date(item.time_in_silo).getFullYear() ===
                        2006 ? '' : new Date(item.time_in_silo), main_entrance_in_hopper: new Date(item.main_entrance_in_hopper).getFullYear() ===
                        2006 ? '' : item.main_entrance_in_hopper, time_in_hopper: new Date(item.time_in_hopper).getFullYear() ===
                        2006 ? '' : item.time_in_hopper, time_out_hopper: new Date(item.time_out_hopper).getFullYear() ===
                        2006 ? '' : item.time_out_hopper });
            })
        };
        dispatch({ type: hauling_statistic_types_1.haulingStatisticTypes.SET_DATA_GRID, payload });
    }
});
const onDataStateChange = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = { dataStates };
    dispatch({ type: hauling_statistic_types_1.haulingStatisticTypes.ON_PAGE_CHANGE, payload });
});
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: hauling_statistic_types_1.haulingStatisticTypes.ON_MUTATION_CLICK, payload });
};
const onFilterChange = payload => dispatch => {
    dispatch({ type: hauling_statistic_types_1.haulingStatisticTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = payload => dispatch => {
    dispatch({ type: hauling_statistic_types_1.haulingStatisticTypes.ON_SORT_CHANGE, payload });
};
const onCloseError = () => dispatch => {
    dispatch({
        type: hauling_statistic_types_1.haulingStatisticTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false
        }
    });
};
const exportDocuments = ({ dataStates, start_date, end_date, type }) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, hauling_statistic_1._exportReportHaulingStatistic)(dataStates, start_date, end_date, type);
    if (response.isError) {
        dispatch({
            type: hauling_statistic_types_1.haulingStatisticTypes.SET_ERROR, payload: {
                isError: response.isError,
                errorCode: response.errorCode, errorMessage: response.errorMessage
            }
        });
    }
    else {
        dispatch({ type: hauling_statistic_types_1.haulingStatisticTypes.SET_EXPORT_DOCUMENTS_URL, payload: response });
    }
});
const clearDocuments = () => dispatch => {
    dispatch({ type: hauling_statistic_types_1.haulingStatisticTypes.CLEAR_EXPORT_DOCUMENTS_URL, payload: '' });
};
const onDateChange = (payload) => dispatch => {
    dispatch({ type: hauling_statistic_types_1.haulingStatisticTypes.ON_DATE_CHANGE, payload });
};
exports.default = {
    getDataGrid,
    onCloseError,
    onSortChange,
    onFilterChange,
    onClickMutation,
    onDataStateChange,
    exportDocuments,
    clearDocuments,
    onDateChange
};
